import { render, staticRenderFns } from "./ShowCursos.vue?vue&type=template&id=0130b60e&"
import script from "./ShowCursos.vue?vue&type=script&lang=js&"
export * from "./ShowCursos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports